import React, { useState } from 'react';

import productServices from '../../../../../../services/admFin/productServices';

import { Dots } from "react-activity";

import Popup from '../../../../../../components/Popup';
import Input from '../../../../../../components/Input';
import { FaCube } from 'react-icons/fa';

export default function PopupProductNewMovement(props) {
    const [quantity, setQuantity] = useState(0);
    const [movementType, setMovementType] = useState("");
    const [description, setDescription] = useState("");
    const [fetching, setFetching] = useState(false);

    async function createStockMovement() {
        if (props.product && props.product.id && movementType && quantity) {
            setFetching(true);
            const response = await productServices.postStockMovement(
                props.product.id,
                productServices.stockMovementTypes.find(item => item[1] === movementType)[0],
                quantity,
                description
            );
            setFetching(false);
            if (response.status === 201) {
                if (props.onCreate) props.onCreate();
                props.setVisibility(false);
                setQuantity(0);
                setMovementType("");
                setDescription("");
            } else
                alert("Erro ao movimentar estoque, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaCube />}
            tittle="Nova movimentação"
            id="new-movement"
        >
            <form>
                <span className='tag large dark-blue'><b>Produto:</b>{props.product.nome}</span>
                
                <div className="line">
                    <Input
                        label="Quantidade*"
                        type='number'
                        id='popup-product-new-movement-quantity '
                        onChange={(event) => setQuantity(Number(event.target.value))}
                        value={quantity}
                    />
                    <Input
                        label="Movimentação*"
                        type='select'
                        noFilterOptions
                        options={productServices.stockMovementTypes.slice(0, 2).map(item => item[1])}
                        id='popup-product-new-movement-movement-type'
                        onChange={(event) => setMovementType(event.target.value)}
                        value={movementType}
                    />
                </div>
                <Input
                    label="Descrição"
                    placeholder="Insira aqui uma descrição"
                    type="textarea"
                    id="popup-product-new-movement-description"
                    onChange={(event) => setDescription(event.target.value)}
                    value={description}
                />
                <button
                    type="button"
                    onClick={() => fetching ? alert("Um envio já está em andamento.") : createStockMovement()}
                >
                    {
                        fetching ?
                            <Dots />
                            : "Registrar"
                    }
                </button>
            </form>
        </Popup>
    )
}